<template>

    <div class="col span_4_of_12 span_4_of_12-tl span_6_of_12-tp span_6_of_12-sl span_12_of_12-sp lw-community-card lw-community-card2 lw-card-mb learnworlds-align-left va-sb lw-body-bg flex-item lw-padding-small non-flexible lw-b-1px-fadeout80" @click="emitAction('card-clicked')">
        <div class="lw-card-top">
            <div class="flex-item fg-0 va-sb">   
                <div class="lw-cols one-row one-row-tl one-row-tp one-row-sl one-row-sp align-items-center">
                    <div class="col flex-item no-padding span_2_of_12 span_2_of_12-tl span_2_of_12-tp span_2_of_12-sl span_2_of_12-sp">
                        <div class="learnworlds-image learnworlds-bg-default stretched-bg learnworlds-framed-image learnworlds-element learnworlds-frame-size-full square"
                            :style="'background-image: url(' + item.avatarImg + ');'"></div>
                    </div>
                    <div class="col flex-item no-padding span_10_of_12 span_10_of_12-tl span_10_of_12-tp span_10_of_12-sl span_10_of_12-sp">
                        <div class="lw-community-card-name learnworlds-overline-text learnworlds-element">
                            {{ item.user_id.username }}
                        </div>
                    </div>
                </div>
                <div class="lw-interior-mt">
                    <div class="learnworlds-overline-text lw-brand-accent1-text learnworlds-element no-margin-bottom">
                        {{ item.date }}
                    </div>
                    <div class="lw-community-card-descr learnworlds-main-text learnworlds-element learnworlds-main-text-small" v-html="item.preview_text" style="pointer-events: none">

                    </div>
                </div>
            </div>
        </div>
        <div class="lw-interior-mt">
            <div class="lw-cols">
                <div class="col span_4_of_12-all no-padding flex-item with-flexible-parts non-flexible">
                    <span class="learnworlds-main-text-small no-margin-bottom flexible-part learnworlds-icon fas fa-comment-dots"></span>
                    <div class="flexible-part learnworlds-main-text learnworlds-main-text-small learnworlds-element" > {{ item.counters.comments }}</div>
                </div>
                <div class="col span_4_of_12-all no-padding flex-item with-flexible-parts non-flexible">
                    <span  class="learnworlds-main-text-small no-margin-bottom flexible-part learnworlds-icon fas fa-star" ></span>
                    <div class="flexible-part learnworlds-main-text learnworlds-main-text-small learnworlds-element"> {{ item.counters.likes }}</div>
                </div>
                <div class="col span_4_of_12-all no-padding flex-item with-flexible-parts non-flexible">
                    <span class="learnworlds-main-text-small no-margin-bottom flexible-part learnworlds-icon fas fa-award" ></span>
                    <div class="flexible-part learnworlds-main-text learnworlds-main-text-small learnworlds-element"> {{ item.counters.best_of }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ComponentTemplatesMixin from "../../mixins/ComponentTemplatesMixin";

    export default {
        name: "CommunityPostsCard2",
        props: ["item"],
        mixins: [ComponentTemplatesMixin],
        data () {
            return {
            }
        },

    }
</script>

